import React from 'react'
import { Skeleton, Box } from '@mui/material'
import './loading.css'
const rowStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 1,
}
const skeletonStyles = {
  height: 64,
  width: '100%',
}
const FormLoading = () => {
  return (
    <Box>
      <Box sx={rowStyle}>
        <Skeleton animation='wave' sx={skeletonStyles} />
        <Skeleton animation='wave' variant='circular' width={40} height={40} sx={skeletonStyles} />
      </Box>
      <Box sx={rowStyle}>
        <Skeleton animation='wave' sx={skeletonStyles} />
        <Skeleton animation='wave' sx={skeletonStyles} />
      </Box>
      <Box sx={rowStyle}>
        <Skeleton animation='wave' width={'70%'} sx={{ ...skeletonStyles, bgcolor: 'background.defaultdim' }} />
        <Skeleton animation='wave' width={'30%'} sx={{ ...skeletonStyles, bgcolor: 'background.defaultdim' }} />
      </Box>

      <Skeleton animation='wave' sx={skeletonStyles} />
      <Skeleton animation='wave' sx={skeletonStyles} />
      <Box sx={rowStyle}>
        <Skeleton animation='wave' sx={skeletonStyles} />
        <Skeleton animation='wave' sx={skeletonStyles} />
      </Box>
      <Skeleton animation='wave' sx={skeletonStyles} />
    </Box>
  )
}

export default FormLoading
